var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlane(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18655 0.802158C9.1003 0.741033 8.98705 0.732783 8.8933 0.781908L0.455829 5.18814C0.356079 5.24027 0.297204 5.34677 0.305454 5.45889C0.314079 5.57139 0.388704 5.66739 0.494829 5.70377L2.84045 6.50551L7.8358 2.23428L3.97032 6.89139L7.90143 8.23501C7.93068 8.24476 7.96143 8.25001 7.99218 8.25001C8.04318 8.25001 8.0938 8.23613 8.13843 8.20913C8.20968 8.16563 8.25805 8.09251 8.27043 8.01038L9.30167 1.07291C9.31705 0.967907 9.2728 0.863658 9.18655 0.802158Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.5788c83c55976a5e0a57361d9e28a9e4.svg";
export { ForwardRef as ReactComponent };